import moment from 'moment-timezone';
import { appTimezone } from '@ss/config';
export function initializeMoment() {
    moment.tz.setDefault(appTimezone);
}
